import { WizardConfig } from 'components/wizard/types';
import { PcwStep } from './types';
import {
    validateForwardCurveConstraintsStep,
    validateGlobalShapesStep,
    validateHydroStep,
    validatePortfolioBasics,
    validatePortfolioType,
} from './validation';
import { PortfolioTypeStep } from './steps/PortfolioTypeStep';
import { PortfolioBasicsStep } from './steps/PortfolioBasicsStep';
import { ForwardCurvesStep } from './steps/ForwardCurvesStep';
import { GlobalShapesStep } from './steps/GlobalShapesStep';
import { SummaryStep } from './steps/SummaryStep';
import { LoadStep } from './steps/LoadStep';
import { AddAssetsStep } from './steps/AddAssetsStep';
import { HydroStep } from './steps/HydroStep';
import { AncillariesStep } from './steps/AncillariesStep';
import { HedgesContractsStep } from './steps/HedgesContractsStep';
import { ancillariesStepNavigation } from './navigation';
import { createPortfolioPayload, submitPortfolioWizard } from './util';
import { PCWPortfolioCreateRequest } from 'types/portfolios';
import { ForwardCurveConstraintsStep } from './steps/ForwardCurveConstraintsStep';

export const pcwWizardConfig: WizardConfig<PcwStep, PCWPortfolioCreateRequest> = {
    wizardId: 'pcw-wizard',
    showDetailsInWrapper: false,
    createPayload: createPortfolioPayload,
    submitWizard: submitPortfolioWizard,
    firstStepId: 'portfolio-type-selection',
    title: { id: 'wizard_pcw_title' },
    steps: {
        'portfolio-type-selection': {
            id: 'portfolio-type-selection',
            title: { id: 'wizard_pcw_type_selection_step_title' },
            info: { id: 'wizard_pcw_type_selection_step_info' },
            component: PortfolioTypeStep,
            validate: validatePortfolioType,
            next: 'portfolio-basics',
        },
        'portfolio-basics': {
            id: 'portfolio-basics',
            title: { id: 'wizard_pcw_basics_step_title' },
            component: PortfolioBasicsStep,
            validate: validatePortfolioBasics,
            next: 'add-forward-curves',
            confirmOnBack: true,
        },
        'add-forward-curves': {
            id: 'add-forward-curves',
            title: { id: 'wizard_pcw_forward_curves_step_title' },
            info: { id: 'wizard_pcw_forward_curves_step_description' },
            component: ForwardCurvesStep,
            next: 'add-forward-curves-constraints',
            confirmOnBack: true,
        },
        'add-forward-curves-constraints': {
            id: 'add-forward-curves-constraints',
            title: { id: 'wizard_pcw_forward_curves_constraints_step_title' },
            info: { id: 'wizard_pcw_forward_curves_constraints_step_description' },
            component: ForwardCurveConstraintsStep,
            validate: validateForwardCurveConstraintsStep,
            next: 'add-global-shapes',
            confirmOnBack: true,
        },
        'add-global-shapes': {
            id: 'add-global-shapes',
            title: { id: 'wizard_pcw_global_shapes_step_title' },
            info: { id: 'wizard_pcw_shape_set_step_description' },
            component: GlobalShapesStep,
            validate: validateGlobalShapesStep,
            next: 'add-load',
            confirmOnBack: true,
        },
        'add-load': {
            id: 'add-load',
            title: { id: 'wizard_pcw_load_step_title' },
            component: LoadStep,
            next: 'add-assets',
            confirmOnBack: true,
        },
        'add-assets': {
            id: 'add-assets',
            title: { id: 'wizard_pcw_assets_step_title' },
            info: { id: 'wizard_pcw_assets_step_description' },
            component: AddAssetsStep,
            next: 'add-hydro',
            confirmOnBack: true,
        },
        'add-hydro': {
            id: 'add-hydro',
            title: { id: 'wizard_pcw_hydro_assets_step_title' },
            info: { id: 'wizard_pcw_hydro_step_description' },
            component: HydroStep,
            validate: validateHydroStep,
            next: ancillariesStepNavigation,
            confirmOnBack: true,
        },
        'add-ancillaries': {
            id: 'add-ancillaries',
            title: { id: 'wizard_pcw_ancillaries_step_title' },
            info: { id: 'wizard_pcw_ancillaries_step_description' },
            component: AncillariesStep,
            next: 'add-hedges-contracts',
            confirmOnBack: true,
        },
        'add-hedges-contracts': {
            id: 'add-hedges-contracts',
            title: { id: 'wizard_pcw_hedges_contracts_step_title' },
            info: { id: 'wizard_pcw_hedges_contracts_step_description' },
            component: HedgesContractsStep,
            next: 'summary-step',
            confirmOnBack: true,
        },
        'summary-step': {
            id: 'summary-step',
            percentComplete: 100,
            title: { id: 'wizard_pcw_summary_step_title' },
            component: SummaryStep,
            confirmOnBack: false,
        },
    },
};
